module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAN1wAADdcBQiibeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAACdSURBVEiJ7dHBCgFhFMXxGUU2YmEjD8W8BDvlLWWkrCTvoOQBfjY3WTAzPiuaU3fxdc85/7pfltUIPSxR4hKzxQLdunxd+RR777XDJLW8j0MUnTDHOKbAOXZ79FIA6yg4YvRiPwowrFIAZYRnFZ4iPJsUwC3CgwrPMDzXFAD41tf5mPyhWkCt8udHk09tVJrnj97fP1ELaAEt4B8Ad6BxyJHkrqf4AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/lock.png
// module id = 2528
// module chunks = 1707 1721 1726